import React from 'react';
import { Select, Form, Tooltip } from 'antd';
import InfoTooltip from '../InfoTooltip/InfoTooltip';
import {
  ToolConfigDataAccess,
  ToolConfigDataTypeAccess,
} from '../../interfaces/toolConfig';
import { BaseOptionType, DefaultOptionType } from 'antd/es/select';

const DATATYPE_OPTIONS = [
  {
    key: 'metadata',
    label: 'Metadata',
    info: 'Objects, fields, layouts, permission sets, profiles, etc.',
  },
  { key: 'user_data', label: 'User Data', info: 'Users, groups. queues, etc.' },
  {
    key: 'personal_setup_data',
    label: 'Personal Setup Data',
    info: 'Reports, email templates, dashboards, etc.',
  },
  {
    key: 'business_data',
    label: 'Business Data',
    info: 'Leads, accounts, contacts, etc.',
  },
];

interface DataAccessLevelFormItemsProps {
  getOption: (
    level: ToolConfigDataTypeAccess,
    dataTypeOpt: { key: string; label: string; info: string }
  ) => BaseOptionType | DefaultOptionType;
  disabled?: boolean;
  dataTestId?: string;
}

const DataAccessLevelSelect: React.FC<DataAccessLevelFormItemsProps> = ({
  getOption,
  disabled,
  dataTestId,
}) => {
  return (
    <>
      {DATATYPE_OPTIONS.map((dataTypeOpt) => (
        <Form.Item
          key={dataTypeOpt.key}
          name={dataTypeOpt.key as keyof ToolConfigDataAccess}
          label={
            <span className="form-label">
              {dataTypeOpt.label}&nbsp;
              <InfoTooltip content={dataTypeOpt.info} />
            </span>
          }
          className="form-item"
        >
          <Select
            data-testid={`${dataTestId}-${dataTypeOpt.key}`}
            disabled={disabled}
            options={[
              ToolConfigDataTypeAccess.None,
              ToolConfigDataTypeAccess.Read,
              ToolConfigDataTypeAccess.Write,
            ].map((o) => getOption(o, dataTypeOpt))}
            optionRender={(option) => (
              <div
                data-testid={`${dataTestId}-${dataTypeOpt.key}-${option.data.value}`}
              >
                <Tooltip title={option.data.tooltip}>
                  {option.data.label}
                </Tooltip>
              </div>
            )}
          />
        </Form.Item>
      ))}
    </>
  );
};

export default DataAccessLevelSelect;
